import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../redux/manageRepaymentsForm/actions";
import { ErrorFocus } from "../../../components/render/errorFocus";
import { UnStyledButton } from "../../../components/button/button.styles";
import { FormErrorHandler } from "../../../components/formErrorModal";
import { LoaderBackground } from "../../Forms/containers/shared/ApplyBankStep/components/loaderBackground";
import { ManageMyRepaymentModal } from "./manageMyRepaymentModal";
import { useHistory } from "react-router";
import { PRIVATE_ROUTE } from "../../../route.constants";

export const ManageRepaymentForm = ({ buttonText, endpoint, initialValues, validationSchema, children, modalMessage, isActive }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { loanFormError, isFetching, loanFormSuccessfullySubmitted } = useSelector((state) => state.manageRepaymentsForm);
  const [showModal, setShowModal] = useState(false);

  const handleSubmit = (values, formikHelpers) => {
    const { setSubmitting } = formikHelpers;
    setSubmitting(true);
    try {
      dispatch(actions.postRequest({ values, endpoint }));
    } catch (err) {
      console.log(err);
    } finally {
      setSubmitting(false);
    }
  };

  const closeModalResetForm = () => {
      dispatch(actions.resetForm());
      setShowModal(false);
      history.push({
        pathname: PRIVATE_ROUTE.MANAGE_REPAYMENTS,
      });
  };

  useEffect(() => {
      if (loanFormSuccessfullySubmitted === true && isActive === true) {
        setShowModal(true);
      }
  }, [loanFormSuccessfullySubmitted, isActive]);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize
      validateOnChange
      validateOnBlur
      validateOnMount
      onSubmit={(values, formikHelpers) => handleSubmit(values, formikHelpers)}
    >
      {(formProps) => (
        <>
          {children}
          <ErrorFocus />
          <div className="manage-repayment-submit">
            <UnStyledButton onClick={formProps.submitForm} className="manage-repayment-pay-higher-button">
              {buttonText}
            </UnStyledButton>
          </div>
          <FormErrorHandler actions={actions} loanFormError={loanFormError} />
          <LoaderBackground loading={isFetching} />
          <ManageMyRepaymentModal visible={showModal} close={() => closeModalResetForm()} header="Success">
            {modalMessage}
          </ManageMyRepaymentModal>
        </>
      )}
    </Formik>
  );
};
